<div
  class="font-lato flex items-center justify-between border-b border-gray-100 px-5 py-3 text-sm text-black"
>
  <span>Transaction history available for the past 24 months.</span>
  @if (payments().length > 0) {
    <button
      type="button"
      [disabled]="!canExport() || isExporting()"
      class="btn-secondary h-9! px-4! text-xs!"
      [attr.aria-label]="
        isExporting()
          ? 'Exporting transactions'
          : 'Export all transactions as CSV'
      "
      (click)="downloadCsv()"
    >
      @if (isExporting()) {
        <svg
          class="mr-2 size-4 animate-spin text-black!"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        Exporting...
      } @else {
        <mat-icon
          svgIcon="csv_file"
          class="mr-2 h-4! w-4!"
          aria-hidden="true"
        ></mat-icon>
        <span>Export</span>
      }
    </button>
  }
</div>

@if (isPaymentsLoading()) {
  <ul class="animate-pulse" role="status" aria-label="Loading transactions">
    @for (row of [1, 2, 3, 4, 5, 6]; track row) {
      <li
        class="flex items-center gap-4 border-b border-gray-100 px-5 py-4"
        aria-hidden="true"
      >
        <div class="h-10 w-10 shrink-0 rounded-full bg-gray-200"></div>
        <div class="flex flex-1 flex-col gap-2">
          <div class="h-4 w-40 rounded bg-gray-200"></div>
          <div class="h-3 w-32 rounded bg-gray-200"></div>
        </div>
        <div class="h-5 w-16 rounded-full bg-gray-200"></div>
        <div class="h-4 w-24 rounded bg-gray-200"></div>
      </li>
    }
  </ul>
}

@if (payments().length === 0 && !isPaymentsLoading()) {
  <div
    role="status"
    aria-live="polite"
    class="flex flex-col items-center justify-center gap-4 px-4 py-12"
  >
    <mat-icon
      fontIcon="history"
      class="text-gray-300"
      [style.font-size.px]="48"
      [style.width.px]="48"
      [style.height.px]="48"
      aria-hidden="true"
    ></mat-icon>
    <div class="text-center">
      <h3 class="font-montserrat mb-1 text-base font-semibold text-black">
        No transactions yet
      </h3>
      <p class="font-lato text-sm text-gray-600">
        Transactions will appear here as they are processed. Transaction history
        is available for the past 24 months.
      </p>
    </div>
  </div>
}

<ul aria-label="Transactions">
  @for (group of groupedPayments; track group.month) {
    <li>
      <div class="border-b-2 border-gray-200 bg-[#f7f7f7] px-5 py-2">
        <h3 class="font-lato text-xs font-bold tracking-wider uppercase">
          {{ group.month }}
        </h3>
      </div>

      <ul>
        @for (payment of group.payments; track payment.Id) {
          <li
            class="hover:bg-blue-75 flex items-center border-b border-gray-100 transition-colors last:border-b-0"
          >
            <div
              class="flex w-16 shrink-0 items-center justify-center border-r border-gray-100 py-4 text-blue-700"
              aria-hidden="true"
            >
              <mat-icon
                class="h-7! w-7! text-[28px]!"
                fontIcon="attach_money"
                aria-hidden="true"
              ></mat-icon>
            </div>
            <div class="flex flex-1 flex-col px-5 py-4">
              <span class="font-lato text-sm text-black">
                Payment received
              </span>
              <span class="font-lato text-brand-muted text-xs">
                <time [attr.datetime]="payment.Transaction_Date__c">
                  {{ payment.Transaction_Date__c | date: 'MMM d, yyyy' }}
                </time>
              </span>
            </div>
            <div class="flex shrink-0 items-center gap-4 pr-5">
              <span
                class="font-lato rounded px-2 py-0.5 text-[11px] font-semibold tracking-wide uppercase"
                [ngClass]="getStatusClasses(payment)"
                [attr.aria-label]="'Status: ' + getStatusLabel(payment)"
              >
                {{ getStatusLabel(payment) }}
              </span>
              <span
                class="font-montserrat text-sm font-semibold text-gray-700 tabular-nums"
              >
                {{
                  getDisplayAmount(payment)
                    | currency: 'USD' : 'symbol' : '1.2-2'
                }}
              </span>
            </div>
          </li>
        }
      </ul>
    </li>
  }
</ul>
